module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cvip-dialog-wrap",
    on: {
      "mousewheel": _vm.stopMouseWheel
    }
  }, [_c('div', {
    staticClass: "cvip-dialog",
    style: ({
      width: _vm.widthnew,
      height: _vm.heightnew
    })
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.showBtn === true) ? _c('div', {
    staticClass: "dialog-btm"
  }, [_c('div', {
    staticClass: "btn-wrap",
    on: {
      "click": function($event) {
        return _vm.btnClick();
      }
    }
  }, [_c('p', {
    staticClass: "btn",
    class: {
      'disabled': _vm.disabled, oldVerVip: _vm.oldVerVip
    },
    domProps: {
      "textContent": _vm._s(_vm.disabled ? '不能' + _vm.btnTxt : _vm.btnTxt)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "close-btn",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53f5b53b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/common/CvipDialog.vue
// module id = JJUd
// module chunks = 1